// extracted by mini-css-extract-plugin
module.exports = {"progressCell":"progressCell__9znNS","viewDetails":"viewDetails__DV6Df","progressStatus":"progressStatus__WTLM+","label":"label__xLJTN"};